import { useEffect, useState } from "react";
import Loader from "../../../../components/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import {
  formatDateWithoutTime,
  validDateRegex,
} from "../../../../utilities/helper";
import style from "./SubjectVisit.module.css";
import { DynamicForm } from "../../DynamicForm/DynamicForm";
import { getSubjectLoadDataService } from "../../../../services/subjectService";

const SubjectVisit = () => {
  const [load, setLoad] = useState(false);
  const [questionData, setQuestionData] = useState([]);
  const [allQuestionsData, setAllQuestionsData] = useState(null);
  const [jsonStrings, setJsonStrings] = useState([]);
  const [pageName, setPageName] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [subjectDetails, setSubjectDetails] = useState({
    visitName: "",
    subjectNumber: "",
    subjectStatus: "",
    vistId: "",
    attributes: [],
    prevCompletedVisit: "",
    prevCompletedVisitDate: "",
  });
  const navigate = useNavigate();

  const siteId = useLocation()?.state?.siteId;
  const id = useLocation()?.state?.id;
  const nextVisitId = useLocation()?.state?.nextVisitId;
  const access_token = localStorage?.getItem("access_token");

  const {
    visitName,
    subjectNumber,
    vistId,
    subjectStatus,
    attributes,
    prevCompletedVisit,
    prevCompletedVisitDate,
  } = subjectDetails;

  useEffect(() => {
    if (siteId && id && nextVisitId) {
      getSubjectVisitLoadData(access_token, siteId, id, nextVisitId);
    }
  }, [siteId, access_token, id, nextVisitId]);

  useEffect(() => {
    if (questionData && questionData?.length > 0) {
      let tempArray = [];
      questionData?.forEach((item) => {
        let obj = JSON.parse(item?.json);
        obj.answer_id = item?.answers[0]?.questionId;
        const updatedJsonString = JSON.stringify(obj, null);
        tempArray.push(updatedJsonString);
      });

      setJsonStrings(tempArray);
    }
  }, [questionData]);

  const getSubjectVisitLoadData = async (
    access_token,
    siteId,
    id,
    nextVisitId,
  ) => {
    setLoad(true);
    const data = {
      patientId: id,
      siteId: siteId,
      visitId: nextVisitId || 0,
      pageId: null,
    };
    try {
      const res = await getSubjectLoadDataService(access_token, data);
      if (res?.data?.status == 200) {
        setLoad(false);
        const patiendData = res?.data?.result?.patientVisitData?.patient;
        setQuestionData(
          res?.data?.result?.patientVisitData?.questionnaire?.questions,
        );
        setAllQuestionsData(res?.data?.result);
        setPageName(
          res?.data?.result?.patientVisitData?.questionnaire?.internalName,
        );
        setSubjectDetails({
          ...subjectDetails,
          attributes: patiendData?.attributes,
          subjectStatus: patiendData?.patientStatus,
          subjectNumber: patiendData?.patientNumber,
        });
      }
    } catch (err) {
      console.log(err);
      setLoad(false);
      if (err?.status == 404) {
        navigate("/unAuthorized");
      }
    }
  };

  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <div className="content-body">
          <p className="bread-crumbs-link-container">
            <button
              className="bread-crumbs-btn"
              onClick={(e) => {
                navigate("/");
              }}
            >
              Home
            </button>{" "}
            |{" "}
            <button
              className="bread-crumbs-btn"
              onClick={(e) => {
                navigate("/subject");
              }}
            >
              Subject Management
            </button>{" "}
            | <button className="bread-crumbs-btn">Subject Visit</button>-{" "}
            <b style={{ color: "gray" }}>
              {localStorage?.getItem("studyName")}
            </b>
          </p>

          {!showConfirm && (
            <>
              {allQuestionsData && (
                <div className={style?.subjectVisitDetailContainer}>
                  <div>
                    <h2 className={style?.subjectVisitHeading}>{pageName}</h2>
                    <h5 className={style?.subjectVisitHeading}>
                      {subjectNumber}
                    </h5>
                    <h5 className={style?.subjectVisitHeading}>
                      {subjectStatus}
                    </h5>
                  </div>
                  <div className={style?.subjectDetailMainContainer}>
                    {attributes?.map((item) => (
                      <div
                        className={style?.subjectDetailOuterContainer}
                        key={item?.keyName}
                      >
                        <span className={style?.subjectDetailName}>
                          {item?.label}
                        </span>
                        <span className={style?.subjectDetailValue}>
                          {validDateRegex.test(item?.value)
                            ? formatDateWithoutTime(item?.value)
                            : item?.value}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}

          {/* Dynamic Form Rendering */}

          {jsonStrings?.length > 0 ? (
            <DynamicForm
              fieldJsonList={jsonStrings}
              allQuestionsData={allQuestionsData}
              setLoad={setLoad}
              setShowConfirm={setShowConfirm}
              showConfirm={showConfirm}
              responseData={responseData}
              setResponseData={setResponseData}
              setLanguageData={null}
              pageName={pageName}
              showLinks={false}
            />
          ) : (
            <h3 className={style?.noQuestionsAvailable}>
              {" "}
              No questions available
            </h3>
          )}
        </div>
      )}
    </>
  );
};

export default SubjectVisit;
